import axiosInstance from './axiosInstance';

export interface PacienteRequest {
  nombre: string;
  apellido: string;
  dni: string;
  email: string;
  particular: boolean;
  nroAfiliado: string;
  obraSocial: string;
}

export interface PacienteResponse {
  id: string;
  nombre: string;
  apellido: string;
  dni: string;
  email: string | null;
  particular: boolean;
  nroAfiliado: string | null;
  obraSocial: string | null;
  createdAt: string;
}

export async function listarPacientes(): Promise<PacienteResponse[]> {
  const response = await axiosInstance.get<PacienteResponse[]>('/api/pacientes');
  return response.data;
}

export async function crearPaciente(data: PacienteRequest): Promise<PacienteResponse> {
  const response = await axiosInstance.post<PacienteResponse>('/api/pacientes', data);
  return response.data;
}

export async function actualizarPaciente(id: string, data: PacienteRequest): Promise<PacienteResponse> {
  const response = await axiosInstance.put<PacienteResponse>(`/api/pacientes/${id}`, data);
  return response.data;
}

export async function buscarPacientes(q: string): Promise<PacienteResponse[]> {
  const response = await axiosInstance.get<PacienteResponse[]>('/api/pacientes/buscar', { params: { q } });
  return response.data;
}
